import React, { useRef, useState } from 'react';

import {
  Box,
  Container,
  Grid,
  Link,
  Typography,
  Stack,
  Divider,
  IconButton,
  Button
} from '@mui/material';

function ThirdEventView(){
  return (
    <Box sx={{width:'100%', height:'100%', backgroundImage:'url(/assets/images/daclair_des2.png)', backgroundSize:'cover', backgroundPosition:'center', position:'relative'}}>
      <Box sx={{position:'absolute', top:0, left:0, width:'100%', height:'100%', backgroundColor:'rgba(0,0,0,0.6)'}}/>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        sx={{position:'absolute', top:0, bottom:0, width:'100%', color:'#fff', px:2}}
        spacing={2}>
        <Typography variant="h3" sx={{fontWeight:700, fontFamily:'NotoSansKR', textAlign:'center'}}>최신 소식 & 이벤트</Typography>
        <Typography variant="h6" sx={{maxWidth:600, textAlign:'center'}}>새로운 캠페인과 업데이트를 확인하세요. 가입자에게만 제공되는 혜택도 놓치지 마세요.</Typography>
        <Button variant="outlined" color="secondary" href="/notices" sx={{mt:2}}>자세히 보기</Button>
      </Stack>
    </Box>
  );
}

export default ThirdEventView;
